"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var FOOTER_HEIGHT = 52;
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      padding: spacing(2),
      paddingTop: spacing(2),
      width: '100%',
      height: '100%',
      marginBottom: FOOTER_HEIGHT
    },
    scrollableContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    },
    title: {
      fontSize: 16,
      lineHeight: 1.5,
      color: palette.text.primary,
      marginBottom: 15,
      fontWeight: 'bold'
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'fixed',
      padding: spacing(0, 2),
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      backgroundColor: palette.common.white,
      width: '100%',
      height: FOOTER_HEIGHT,
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)'
    },
    nextButtonToRight: {
      justifyContent: 'flex-end'
    },
    bigButton: {
      height: 48,
      minWidth: 169
    },
    bigFooter: {
      height: 70
    },
    backButton: {
      color: palette.link.main
    },
    nextBtnIcon: {
      marginRight: spacing(1)
    }
  };
});

var Step = function Step(props) {
  var classes = useStyles(props);
  var title = props.title,
      nextButtonText = props.nextButtonText,
      nextButtonIcon = props.nextButtonIcon,
      onNextClick = props.onNextClick,
      onBackClick = props.onBackClick,
      hideBackButton = props.hideBackButton,
      loading = props.loading,
      contentLoading = props.contentLoading,
      disabled = props.disabled,
      children = props.children,
      buttonSize = props.buttonSize,
      centerContent = props.centerContent;
  var handleNextClick = (0, _react.useCallback)(function () {
    if (!loading) {
      onNextClick();
    }
  }, [onNextClick, loading]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.scrollableContent
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.title
  }, title), contentLoading && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: 5
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    "data-testid": "GiftCreationStepper.Loading"
  })), !contentLoading && /*#__PURE__*/_react.default.createElement(_material.Box, {
    style: {
      width: '100%'
    },
    "data-testid": "GiftCreationStepper.Content"
  }, children)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.footer, {
      [classes.nextButtonToRight]: hideBackButton,
      [classes.bigFooter]: buttonSize === 'large'
    })
  }, !hideBackButton && /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: onBackClick,
    className: classes.backButton,
    "data-testid": "GiftCreationStepper.BackButton"
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "arrow-left"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1
  }, "Back")), centerContent, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: buttonSize === 'large' ? classes.bigButton : undefined,
    variant: "contained",
    color: "secondary",
    size: buttonSize,
    startIcon: loading ? /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      size: 20
    }) : nextButtonIcon,
    disabled: disabled,
    onClick: handleNextClick,
    "data-testid": "GiftCreationStepper.NextButton"
  }, nextButtonText)));
};

Step.propTypes = {
  title: _propTypes.default.string.isRequired,
  nextButtonText: _propTypes.default.string.isRequired,
  onNextClick: _propTypes.default.func,
  onBackClick: _propTypes.default.func,
  hideBackButton: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  contentLoading: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  buttonSize: _propTypes.default.oneOf(['small', 'medium', 'large']),
  centerContent: _propTypes.default.node
};
Step.defaultProps = {
  onNextClick: function onNextClick() {},
  onBackClick: function onBackClick() {},
  hideBackButton: false,
  disabled: false,
  loading: false,
  contentLoading: false,
  buttonSize: 'small',
  centerContent: null
};
var _default = Step;
exports.default = _default;